<app-pan-inline-alert [type]="'info'" [icon]="'info'">
  This report is intended to assist the User in identifying suspicious activity and is provided for informational purposes only. Not all
  suspicious activity constitutes theft. Panoptyc does not provide legal advice or advice in connection with any disciplinary actions or
  procedures. Users should review and independently verify all incident data before taking any legal or disciplinary action with respect to
  any particular event.
</app-pan-inline-alert>
